module.exports = __webpack_public_path__ + "img/mi.01cbe97c.svg";